import './app.css';
import Card from './components/card/Card';
import { H2 } from './components/headline/Headline';

function App() {

  return <>
    <H2 text='Unser Angebot' />
    <div className="cards">
      <Card
        linkTo='/gruppenbuchungen'
        thumbnailClass='card__largeGroup'
        title='Exklusive Gruppenmiete'
        description='Unsere Cablesport Arena Pinneberg ganz für Euch allein. Hier wird Euer Traum war! Bucht hier Euren Wunschtermin.'
      />
      <Card
        linkTo='/kurse'
        thumbnailClass='card__courses'
        title='Kurse'
        description='Ihr wollt den Wassersport erlernen oder Eure Skills verfeinern? Dann bucht Euren passenden Kurs jetzt online.' />
      <Card
        linkTo='/gutscheine'
        thumbnailClass='card__voucher'
        title='Gutscheine'
        description='Bestelle Dir hier Deinen individualisierten Onlinegutschein.' />
      <Card
        linkTo='/volleyball'
        thumbnailClass='card__volleyball'
        title='Beachvolleyball und Beachsoccer'
        description='Ihr wollt unseren Platz mieten? Schickt uns hier eine Anfrage.' />
      <Card
        linkTo='/gruppenmiete_oeffentlich'
        thumbnailClass='card__largeGroupPublic'
        title='Gruppenmieten im öffentlichen Betrieb'
        description='Ab 10 Personen könnt Ihr Euch unseren vergünstigten Gruppentarif sichern. Stellt hier Eure Anfrage.' />
      <Card
        linkTo='/events'
        thumbnailClass='card__individual'
        title='Events'
        description='Hier erhaltet Ihr Tickets für unsere hauseigenen Open Air Events.' />
    </div>
  </>;
}

export default App;
